import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class HomeBanner {
    constructor() {
        // this.html = document.querySelector('html');
        this.section = document.querySelector('.components-home-banner');
        this.slider = this.section.querySelector('.swiper');
        this.navigationPrev = this.slider.querySelector('.slider-button-prev');
        this.navigationNext = this.slider.querySelector('.slider-button-next');

        // this.blockBanners = document.querySelectorAll('.block-banner');

        // this.homeSection = document.querySelector('.homeSection');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
        });

        swiper.on('slideChange', () => {
            const previousColor = swiper.slides[swiper.previousIndex].dataset.color;
            const activeColor = swiper.slides[swiper.activeIndex].dataset.color;
            const previousTextColor = swiper.slides[swiper.previousIndex].dataset.textColor;
            const activeTextColor = swiper.slides[swiper.activeIndex].dataset.textColor;
            const stripeTop = this.section.querySelector('.stripe-top');
            const stripeBottom = this.section.querySelector('.stripe-bottom');

            stripeTop.style.backgroundColor = activeColor;
            stripeBottom.style.backgroundColor = activeColor;

            stripeTop.style.color = activeTextColor;
            stripeBottom.style.color = activeTextColor;
        });

        // this.slider.querySelectorAll('.slider-produto').forEach((el) => {
        //     el.addEventListener('click', () => {
        //         const modal = el.dataset.modal;
        //         this.html.classList.add('overflow-hidden');
        //         this.homeSection.classList.add('superPosition');
        //         this.openModal(modal);
        //     });
        // });
    }

    // openModal(modal) {
    //     const modalElement = document.querySelector('#' + modal);
    //     console.log(modalElement);
    //     modalElement.classList.add('active');
    //     modalElement.querySelector('.closeModalBanner').addEventListener('click', () => {
    //         this.html.classList.remove('overflow-hidden');
    //         this.homeSection.classList.remove('superPosition');
    //         this.blockBanners.forEach((elModal) => {
    //             elModal.classList.remove('active');
    //         });
    //     });
    // }
}

if (document.querySelector('.components-home-banner')) {
    new HomeBanner();
}
